import * as Phaser from "phaser";
import {MoveCommand} from "../model/messages";
import {VirtualJoystick} from "./virtual_joystick";
import {VirtualActionButton, ActionButtonCallbacks} from "./virtual_action_button";
import {CANVAS_WIDTH, CANVAS_HEIGHT_TOUCH, CONTROLS_ZONE_HEIGHT} from "./config";

// MobileControls orchestrates the virtual joystick (left) and action button (right)
// within the controls zone rendered below the game canvas.
//
// Layout (portrait, 640px wide):
//   Controls zone: CANVAS_WIDTH × CONTROLS_ZONE_HEIGHT, top edge at MAP_HEIGHT + HUD_HEIGHT
//   Joystick center: x=120, y=(CANVAS_HEIGHT_TOUCH - CONTROLS_ZONE_HEIGHT/2)
//   Action button center: x=CANVAS_WIDTH-120, y=(CANVAS_HEIGHT_TOUCH - CONTROLS_ZONE_HEIGHT/2)

const JOYSTICK_X_OFFSET = 120;
const ACTION_BTN_X_OFFSET = 120;

export class MobileControls {
    private _joystick: VirtualJoystick;
    private _actionButton: VirtualActionButton;

    constructor(scene: Phaser.Scene, callbacks: ActionButtonCallbacks) {
        // Minimum 3 pointers: default (1) + joystick + action button = 3 total
        scene.input.addPointer(2);

        const controlsCenterY = CANVAS_HEIGHT_TOUCH - CONTROLS_ZONE_HEIGHT / 2;

        this._joystick = new VirtualJoystick(
            scene,
            JOYSTICK_X_OFFSET,
            controlsCenterY
        );

        this._actionButton = new VirtualActionButton(
            scene,
            CANVAS_WIDTH - ACTION_BTN_X_OFFSET,
            controlsCenterY,
            callbacks
        );
    }

    /** Returns the current MoveCommand from the joystick (STOP when not touched). */
    getJoystickCommand(): MoveCommand {
        return this._joystick.getCommand();
    }

    /** True when the joystick is actively being moved. */
    isJoystickActive(): boolean {
        return this._joystick.isActive();
    }

    destroy(): void {
        this._joystick.destroy();
        this._actionButton.destroy();
    }
}
